import axios from 'axios'

const httpLogIntegration = axios.create({
  baseURL: 'https://newapi.webreceita.com.br/webreceita/api/v1',
})

export default {
  listar(token, origem = 'sisdev') {
    return httpLogIntegration.get(`integration-logs?origem=${encodeURIComponent(origem)}`, {
      headers: {
        Authorization: token,
      },
    })
  },
}
